// extracted by mini-css-extract-plugin
module.exports = {"bubble":"UserButtonMessage_bubble___jTdY","container":"UserButtonMessage_container__tE2Bw"};